const webViewRules = [
  // if it says it's a webview, let's go with that
  'webview',
  // iOS webview will be the same as safari but missing "Safari"
  '(iphone|ipod|ipad)(?!.*safari)',
  // Android Lollipop and Above: webview will be the same as native but it will contain "wv"
  // Android KitKat to lollipop webview will put {version}.0.0.0
  'android.*(wv|.0.0.0)',
  // old chrome android webview agent
  'linux; u; android',
];

// Because of usage of 'g', this regex is stateful and thus needs to be
// re-created for every test. developer.mozilla.org/JavaScript/Reference/Global_Objects/RegExp/test
export const testWebview = (userAgent: string) =>
  new RegExp(`(${webViewRules.join('|')})`, 'ig').test(userAgent);
